import { IconDeviceGamepad2 } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@cfa/react-core';

import { extractTridionGameInformation } from '@/utils/document-utils';

import { useGameFullscreen } from '@/atoms/document-transient';

interface TridionGameContentProps {
  htmlContent: string | undefined;
}

const TridionGameContent: React.FC<TridionGameContentProps> = ({
  htmlContent,
}) => {
  const { t } = useTranslation();
  const gameInformation = extractTridionGameInformation(htmlContent);

  const [, setIsGameFullscreen] = useGameFullscreen();

  return (
    <div className="flex flex-col gap-5 pt-10">
      <iframe
        allow="fullscreen"
        className="shadow-elevation-8 size-full"
        src={gameInformation?.url}
        title="Game"
      />
      <p className="text-variant-body1 mt-0!" data-testid="GameDescription">
        {gameInformation?.description}
      </p>
      <Button
        className="w-min px-13!"
        color="secondary"
        onPress={() => {
          if (gameInformation?.url) {
            setIsGameFullscreen(true);
          }
        }}
        data-testid="GamePlayNowButton"
      >
        <IconDeviceGamepad2 />
        {t('games.playNow')}
      </Button>
    </div>
  );
};

export default TridionGameContent;
